import { Progress, Button, Typography } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const ModalLayout = ({
    canGoToNextStep,
    selectedCarModel,
    handleNextStep,
    handleBackStep,
    progress,
    children,
    step,
    isManualCarAddMode,
}) => {
    const { t } = useTranslation("cars");

    return !isManualCarAddMode && (step === 0 || step === 1) ? null : (
        <div className="mt-10 space-y-6 h-full">
            <div className="flex items-center justify-center w-full">
                <Title level={3} className="mb-2">
                    {selectedCarModel.make} {selectedCarModel.model} {selectedCarModel.year}
                </Title>
            </div>

            <Progress percent={progress} showInfo={false} strokeColor={"#8A8EFF"} />

            {children}

            <div className="flex justify-end gap-4 mt-8">
                {!!step && (
                    <Button onClick={handleBackStep} className="rounded-full">
                        {t("back")}
                    </Button>
                )}
                <Button type="primary" className="rounded-full" onClick={handleNextStep} disabled={!canGoToNextStep}>
                    {t("next")}
                </Button>
            </div>
        </div>
    );
};

ModalLayout.propTypes = {
    canGoToNextStep: PropTypes.bool.isRequired,
    selectedCarModel: PropTypes.object.isRequired,
    handleNextStep: PropTypes.func.isRequired,
    handleBackStep: PropTypes.func.isRequired,
    progress: PropTypes.number.isRequired,
    children: PropTypes.node.isRequired,
    step: PropTypes.number.isRequired,
    isManualCarAddMode: PropTypes.bool.isRequired,
};

export default ModalLayout;
